import { IndexedDBProps } from 'react-indexed-db-hook'

export const ScanDBConfig: IndexedDBProps = {
  name: "Scan",
  version: 1,
  objectStoresMeta: [
    {
      store: "backstage-catering",
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: "id", keypath: "id", options: { unique: true } },
        { name: "userID", keypath: "userID", options: { unique: false } },
        { name: "userName", keypath: "userName", options: { unique: false } },
        { name: "cateringMealID", keypath: "cateringMealID", options: { unique: false } },
        { name: "timestamp", keypath: "timestamp", options: { unique: false } },
        { name: "terminalID", keypath: "terminalID", options: { unique: false } },
        { name: "isDeleted", keypath: "isDeleted", options: { unique: false } },
      ],
    },
  ],
};